import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import logo from "../../assets/logo-small.webp"
export default function CustomLoader({ style }: { style?: React.CSSProperties }) {
  return (
    <Box
      style={{
        background: "rgba(0,0,0,0.3)",
        zIndex: 999999,
        display: "flex",
        flexDirection: "column",
        position: "fixed",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100vh",
        ...(style || {})
      }}
    >
      <img style={{ width: '5.5em' }} src={logo} className="rotate" alt="Loading" />
      <div>
        <span className="text-loader2" style={{ color: 'white', textShadow: "2px 2px rgba(0,0,0,0.3)" }}>ieq</span>
        <span className="text-loader2" style={{ fontWeight: "lighter" }}>max</span>
      </div>
      {/* <CircularProgress /> */}
    </Box>
  );
}
